var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8484 9.94961C17.8484 11.5236 16.5725 12.7996 14.9984 12.7996C13.4244 12.7996 12.1484 11.5236 12.1484 9.94961C12.1484 8.37559 13.4244 7.09961 14.9984 7.09961C16.5725 7.09961 17.8484 8.37559 17.8484 9.94961Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7008 20.0296C20.7008 22.1896 18.1484 23.95 15.0008 23.95C11.8532 23.95 9.30078 22.1944 9.30078 20.0296C9.30078 17.8648 11.8532 16.1104 15.0008 16.1104C18.1484 16.1104 20.7008 17.8648 20.7008 20.0296Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8808 12.5639C23.8929 13.258 23.4842 13.8908 22.8462 14.1649C22.2083 14.4391 21.4679 14.3002 20.9726 13.8136C20.4773 13.327 20.3254 12.5893 20.5882 11.9466C20.8511 11.3039 21.4764 10.884 22.1708 10.8839C23.1068 10.8759 23.8721 11.6279 23.8808 12.5639Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12136 12.5639C6.10918 13.258 6.51799 13.8908 7.15591 14.1649C7.79385 14.4391 8.53421 14.3002 9.02951 13.8136C9.5248 13.327 9.67668 12.5893 9.41386 11.9466C9.15105 11.3039 8.5257 10.884 7.83136 10.8839C6.89536 10.8759 6.12994 11.6279 6.12136 12.5639Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 21.9342C22.5644 21.8898 22.1271 22.2552 22.0828 22.7503C22.0384 23.2455 22.4038 23.6827 22.8989 23.727L23.0595 21.9342ZM26.3992 20.0298L27.2938 20.1279C27.301 20.0626 27.301 19.9967 27.2938 19.9314L26.3992 20.0298ZM22.8989 16.3338C22.4038 16.3781 22.0384 16.8154 22.0828 17.3105C22.1271 17.8056 22.5645 18.171 23.0595 18.1266L22.8989 16.3338ZM7.09949 23.727C7.59456 23.6827 7.95996 23.2455 7.91563 22.7503C7.87131 22.2552 7.43403 21.8898 6.93895 21.9342L7.09949 23.727ZM3.59922 20.0298L2.70461 19.9314C2.69743 19.9967 2.69742 20.0626 2.70457 20.1279L3.59922 20.0298ZM6.93892 18.1266C7.43399 18.171 7.87128 17.8056 7.91563 17.3105C7.95999 16.8154 7.5946 16.3781 7.09953 16.3338L6.93892 18.1266ZM22.8989 23.727C25.0995 23.9241 27.0532 22.3241 27.2938 20.1279L25.5046 19.9318C25.3707 21.1536 24.2837 22.0438 23.0595 21.9342L22.8989 23.727ZM27.2938 19.9314C27.0525 17.7358 25.099 16.1367 22.8989 16.3338L23.0595 18.1266C24.2835 18.0169 25.3703 18.9066 25.5046 20.1281L27.2938 19.9314ZM6.93895 21.9342C5.71467 22.0438 4.62773 21.1536 4.49387 19.9318L2.70457 20.1279C2.94517 22.3241 4.89889 23.9241 7.09949 23.727L6.93895 21.9342ZM4.49383 20.1281C4.62813 18.9066 5.71493 18.0169 6.93892 18.1266L7.09953 16.3338C4.89947 16.1367 2.94599 17.7358 2.70461 19.9314L4.49383 20.1281Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.a69af79de3750c4356996b5569d8fedc.svg";
export { ForwardRef as ReactComponent };